import MainTemplate from "../MainTemplate.js";
import MainPageLeftSide from "./fragments/MainPageLeftSide.js";
import MainPageMainContent from "./fragments/MainPageMainContent.js";


const MainPage = () => {

  return (
    <MainTemplate
      getUserInfo
      getTierInfo
      LeftSideComponent={(props) => <MainPageLeftSide {...props} />}
      MainComponent={(props) => <MainPageMainContent {...props} />}
    />
  );
};

export default MainPage;
